import { styled, Theme } from '@material-ui/core';

export const ToolboxWrapper = styled('div')<Theme, { hasHeader: boolean }>(({ hasHeader }) => ({
  position: 'absolute',
  width: '56px',
  backgroundColor: '#FFFFFF',
  height: !!hasHeader ? 'calc(100% - 60px)' : '100%',
  top: !!hasHeader ? 60 : 0,
  right: 0,
  borderLeft: '1px solid #EAE6DC',
  padding: '24px 0',
}));

export const ToolboxContent = styled('div')<Theme>(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
}));

export const ToolboxItemWrapper = styled('div')<Theme>(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 16,
}));

export const ToolboxItem = styled('div')<Theme>(() => ({
  cursor: 'pointer',
}));
